module.exports = __webpack_public_path__ + "static/media/noData.9bc39a0b.svg";